import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
// import new_logo from "assets/images/logo/strafinfo-logo-white.webp";
import TopBar from "ThemeLayout/TopBar";
import Footer from "ThemeLayout/footer";
import { handlingApi } from "units/handlingApi";
import { RootState } from "Slices/theme/store";
import { useDispatch, useSelector } from "react-redux";
import { changeAuthenticated, setUser } from "Slices/theme/reducer";
import toast from "react-hot-toast";
import ClipLoader from "react-spinners/ClipLoader";
import Cookies from "js-cookie";
import { useGoogleLogin } from "@react-oauth/google";

const Login = () => {
  const isAuthenticated = useSelector(
    (state: RootState) => state.theme.isAuthenticated
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const token = Cookies.get("token");
  const [googleLoginLoading, setGoogleLoginLoading] = useState(false);

  // const disclaimer = Cookies.get("disclaimer");

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.body.classList.add("register", "page-login");

    if (isAuthenticated || token) {
      navigate("/");
    }

    return () => {
      document.body.classList.remove("register", "page-login");
      setFormData({
        email: "",
        password: "",
      });
    };
  }, []);

  const handleLogin = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    const url = `${apiBaseUrl}user/login`;
    const data = JSON.stringify(formData);

    try {
      const res = await handlingApi({ url, method: "POST", data });

      if (res.statusCode === 200) {
        toast.success(res.message);
        Cookies.set("token", res.token);
        dispatch(changeAuthenticated(true));
        dispatch(setUser(res.user));
        localStorage.setItem("userData", JSON.stringify(res.user));
        navigate("/chatbot");
        setFormData({
          email: "",
          password: "",
        });
        setLoading(false);
      }

      if (res.statusCode === 401) {
        toast.error(res.message);
        console.error(res.message);
        setLoading(false);
      }
    } catch (error: any) {
      toast.error(error.message);
      console.error(error);
      setLoading(false);
    }
  };

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setGoogleLoginLoading(true);
      // Get user info using the access token
      // const userInfo = await axios.get(
      //   "https://www.googleapis.com/oauth2/v3/userinfo",
      //   {
      //     headers: {
      //       Authorization: `Bearer ${tokenResponse.access_token}`,
      //     },
      //   }
      // );

      try {
        const url = `${apiBaseUrl}user/google-login`;
        const data = { token: tokenResponse.access_token };
        const res = await handlingApi({ url, method: "POST", data });

        if (res.statusCode === 200) {
          toast.success(res.message);
          Cookies.set("token", res.token);
          dispatch(changeAuthenticated(true));
          dispatch(setUser(res.user));
          localStorage.setItem("userData", JSON.stringify(res.user));
          navigate("/chatbot");
          setFormData({
            email: "",
            password: "",
          });
        }

        if (res.statusCode === 401) {
          toast.error(res.message);
          setGoogleLoginLoading(false);
        }
      } catch (error: any) {
        console.error("error", error);
        setGoogleLoginLoading(false);
      }
    },
    onError: (error) => {
      setGoogleLoginLoading(false);
      toast.error("Google sign-in failed. Please try again.");
      console.log("Login Failed:", error);
    },
  });

  return (
    <>
      <div className="dash-board-main-wrapper pt--40">
        <TopBar />

        <div className="main-center-content-m-left center-content my-5">
          <div className="rts-register-area">
            <Container>
              <Row className="justify-content-center">
                <Col lg={8}>
                  <div className="single-form-s-wrapper">
                    <div className="head">
                      <span>Welcome back.</span>
                      <h5 className="title">Sign in to continue.</h5>
                    </div>
                    <div className="body">
                      <form onSubmit={handleLogin}>
                        <div className="input-wrapper">
                          <input
                            type="email"
                            placeholder="Enter Your Email."
                            required
                            value={formData.email}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                email: e.target.value,
                              })
                            }
                          />
                          <input
                            type="password"
                            placeholder="Passwort"
                            required
                            value={formData.password}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                password: e.target.value,
                              })
                            }
                          />
                        </div>
                        <button
                          disabled={loading}
                          className={`${
                            loading ? "bg-transparent" : ""
                          } rts-btn btn-primary`}
                          type="submit"
                        >
                          {loading ? (
                            <ClipLoader size={20} color="#00308f" />
                          ) : (
                            "Sign In"
                          )}
                        </button>
                      </form>
                      <div className="other-separator mt-4">
                        <span className="fs-3">Or </span>
                      </div>
                      <button
                        onClick={() => login()}
                        className="sign-in-otherway mt-3"
                      >
                        <div className="single mt-0">
                          <div className="icon">
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.98918 10.878L3.36263 13.217L1.07258 13.2654C0.388195 11.996 0 10.5437 0 9.00034C0 7.50793 0.362953 6.10055 1.00631 4.86133H1.0068L3.04559 5.23511L3.9387 7.26166C3.75177 7.80661 3.64989 8.39161 3.64989 9.00034C3.64996 9.661 3.76963 10.294 3.98918 10.878Z"
                                fill="#FBBB00"
                              ></path>
                              <path
                                d="M17.8422 7.31836C17.9455 7.86279 17.9994 8.42504 17.9994 8.99967C17.9994 9.64402 17.9317 10.2725 17.8026 10.8788C17.3645 12.9419 16.2197 14.7434 14.6338 16.0182L14.6333 16.0177L12.0654 15.8867L11.7019 13.6179C12.7542 13.0007 13.5766 12.035 14.0098 10.8788H9.19727V7.31836H17.8422Z"
                                fill="#518EF8"
                              ></path>
                              <path
                                d="M14.6336 16.0173L14.6341 16.0178C13.0917 17.2575 11.1325 17.9993 8.99968 17.9993C5.57227 17.9993 2.59239 16.0836 1.07227 13.2644L3.98886 10.877C4.74891 12.9054 6.70567 14.3494 8.99968 14.3494C9.98571 14.3494 10.9095 14.0828 11.7021 13.6175L14.6336 16.0173Z"
                                fill="#28B446"
                              ></path>
                              <path
                                d="M14.7442 2.07197L11.8286 4.45894C11.0082 3.94615 10.0385 3.64992 8.99955 3.64992C6.65361 3.64992 4.66025 5.16013 3.93828 7.26131L1.00635 4.86098H1.00586C2.50373 1.97307 5.52119 0 8.99955 0C11.1833 0 13.1855 0.777867 14.7442 2.07197Z"
                                fill="#F14336"
                              ></path>
                            </svg>
                          </div>
                          <p className="mt-0">Sign In With Google</p>
                        </div>
                      </button>
                      <p>
                        Don't have an account?{" "}
                        <Link className="ml--5" to="/register">
                          Sign up for free..
                        </Link>
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Login;
